// extracted by mini-css-extract-plugin
export default {"root":"PolicyForm_root__H2T7+","headingWrapper":"PolicyForm_headingWrapper__zWEFc","form":"PolicyForm_form__IPYA5"};